import { BaseService } from "app/core/base.service";
import { ApiService } from "./api.services";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { ViewModelFiltraProcessoInstitutosLegais } from "../models/ViewModelFiltraProcessoInstitutosLegais.model";
import { ViewModelGridProcessoInstitutosLegais } from "../models/ViewModelGridProcessoInstitutosLegais.model";

export class WebProcessoInstitutosLegaisService extends ApiService implements BaseService<ViewModelFiltraProcessoInstitutosLegais>{

    private strAction = 'api/WebProcessoInstitutosLegais';

    constructor(
        httpClient: HttpClient,
        private route: Router) {
        super(httpClient, route);
    }

    getAll(): Observable<ViewModelFiltraProcessoInstitutosLegais[]> {
        return this.get<ViewModelFiltraProcessoInstitutosLegais[]>(this.strAction + `/GetAll`);
    }

    deleteById(id: number) {
        return this.post(this.strAction + `/DeleteById?id=${id}`);
    }


    getById(id: number): Observable<ViewModelFiltraProcessoInstitutosLegais> {
        return this.get<ViewModelFiltraProcessoInstitutosLegais>(this.strAction + `/GetById/${id}`);
    }


    Put(viewModelFiltraProcessoInstitutosLegais: ViewModelFiltraProcessoInstitutosLegais): Observable<ViewModelFiltraProcessoInstitutosLegais> {
        return this.post<ViewModelFiltraProcessoInstitutosLegais>(this.strAction + `/Put`, viewModelFiltraProcessoInstitutosLegais);
    }

    Post(viewModelFiltraProcessoInstitutosLegais: ViewModelFiltraProcessoInstitutosLegais): Observable<ViewModelFiltraProcessoInstitutosLegais> {
        return this.post<ViewModelFiltraProcessoInstitutosLegais>(this.strAction + `/Post`, viewModelFiltraProcessoInstitutosLegais);
    }
    postFiltroDesligados(viewModelFiltraProcessoInstitutosLegais: ViewModelFiltraProcessoInstitutosLegais): Observable<ViewModelGridProcessoInstitutosLegais[]> {
        return this.post<ViewModelGridProcessoInstitutosLegais[]>(this.strAction + `/PostFiltroDesligados`, viewModelFiltraProcessoInstitutosLegais);
    }


}